import { render, staticRenderFns } from "./BillFlow.vue?vue&type=template&id=1d212790&scoped=true"
import script from "./BillFlow.vue?vue&type=script&lang=js"
export * from "./BillFlow.vue?vue&type=script&lang=js"
import style0 from "./BillFlow.vue?vue&type=style&index=0&id=1d212790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d212790",
  null
  
)

export default component.exports